import React from "react";

import cx from "classnames";

import styles from "./InlineLabel.module.css";

export interface LabelProps {
	className?: string;
	text: string;
}

/*
 * General purpose label/pill component.
 */
function InlineLabel({ text, className }: LabelProps) {
	return <span className={cx(styles.labelBase, className)}>{text}</span>;
}

export default InlineLabel;
